module.exports = __webpack_public_path__ + "static/media/icon-map.1f5e2d65.svg";